import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import format from 'string-template';
import { getViolatingIngredientNames } from '../../../../../../utils/meals';
import { AddButton } from '../../../../../../../components/Button/ActionButtons';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import texts from './texts.json';
import { PlaceFirst } from './styles';

const AddRecipeAction = ({
  data,
  addRecipe,
  mealTimes,
  selectedBucketId,
  variant,
  showSelectionCount,
  excludedIngredients,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [pendingBucketId, setPendingBucketId] = useState(null);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const violatingIngredients = useMemo(() => {
    const recipes = Array.isArray(data) ? data : [data];
    const allIngredients = recipes.flatMap((r) => r.ingredients || []);
    return [...new Set(getViolatingIngredientNames(allIngredients, excludedIngredients))];
  }, [data, excludedIngredients]);

  const handleMealTimeClick = (bucketId) => {
    handleMenuClose();
    if (violatingIngredients.length > 0) {
      setPendingBucketId(bucketId);
    } else {
      addRecipe(bucketId, data);
    }
  };

  const handleConfirm = () => {
    addRecipe(pendingBucketId, data);
    setPendingBucketId(null);
  };

  return (
    <>
      <PlaceFirst>
        <AddButton
          variant={variant}
          onClick={selectedBucketId ? () => addRecipe(selectedBucketId, data) : handleMenuOpen}
        >
          {showSelectionCount
            ? format(texts.addSelectedRecipes, { plural: data.length > 1 ? 's' : '' })
            : texts.addRecipe}
        </AddButton>
        <Menu
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={handleMenuClose}
        >
          {
          !!mealTimes
          && mealTimes.map((mealTime) => (
            <MenuItem
              key={mealTime.name}
              onClick={() => handleMealTimeClick(mealTime.name)}
            >
              {mealTime.name}
            </MenuItem>
          ))
        }
        </Menu>
      </PlaceFirst>
      <ConfirmDialog
        isOpen={!!pendingBucketId}
        onConfirm={handleConfirm}
        onCancel={() => setPendingBucketId(null)}
        dialogTexts={{
          title: texts.dislikedIngredientsTitle,
          content: format(texts.dislikedIngredientsContent, { ingredients: violatingIngredients.join(', ') }),
          confirm: texts.addAnyway,
        }}
      />
      {showSelectionCount && (
      <PlaceFirst>
        <p>
          {format(texts.selectedRecipes, { count: data.length, plural: data.length > 1 ? 's' : '' })}
        </p>
      </PlaceFirst>
      )}
    </>
  );
};

AddRecipeAction.propTypes = {
  data: PropTypes.oneOfType(
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object,
  ),
  addRecipe: PropTypes.func.isRequired,
  mealTimes: PropTypes.array.isRequired,
  selectedBucketId: PropTypes.string,
  variant: PropTypes.string,
  showSelectionCount: PropTypes.bool,
  excludedIngredients: PropTypes.array,
};
AddRecipeAction.defaultProps = {
  selectedBucketId: null,
  variant: 'muted',
  data: {},
  showSelectionCount: false,
  excludedIngredients: [],
};
export default AddRecipeAction;
